import Cart from "./Cart.png";
import Movie from "./Movie.png";
import Rozarpay from "./Rozarpay.png";
import Weather from './weather.png'
import Portfolio from './portfolio.png'
import Blog from './Blog.png'

const data = [
  { id: 0,  description: "",   repo:"",   liveLink:"https://movie-app-amitkumar270802.vercel.app/",               image: Movie,    name: "Movie Website",   Class: 5 },
  { id: 1,  description: "",   repo:"",   liveLink:"https://rozarpay-clone-taupe.vercel.app/",                    image: Rozarpay, name: "Rozarpay Clone",  Class: 5 },
  { id: 2,  description: "",   repo:"",   liveLink:"https://shopping-site-lvvsrx9u9-amitkumar270802.vercel.app/", image: Cart,     name: "Shopping Cart",   Class: 5 },
  { id: 3,  description: "",   repo:"",   liveLink:"https://weather-app-pied-sigma.vercel.app/",                  image:Weather,   name: "Weather Website", Class: 5 },
  { id: 4,  description: "",   repo:"",   liveLink:"https://portfolio-amitkumar270802.vercel.app/",               image:Portfolio, name: "Portfolio",       Class: 5 },
  { id: 5,  description: "",   repo:"",   liveLink:"https://blog-app-amitkumar270802.vercel.app/",                image:Blog,      name: "Blog Website",    Class: 5 },
  
];
export default data;
